import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import 'client/styles/index.scss';

import { Hotel } from 'models/index';
import { MAIN_PAGE_ROUTE } from 'client/constants/routes';
import { useAppSelector, useTranslation } from 'client/hooks';
import { getHotelData } from 'client/redux/hotel/selectors';

import Main from './pages/Main';

import favicon from '../assets/favicon/favicon.png';

import css from './App.module.scss';

const App: React.FC = () => {
  const { translate } = useTranslation('general');
  const data: Hotel.Model | null = useAppSelector(getHotelData);

  const name = data.name ? data.name : data.apiName ? data.apiName : '';

  const renderHelmet = () => {
    return (
      <>
        <Helmet>
          <title>{name}</title>
          <link rel="icon" type="image/png" href={favicon} />
          <meta name="description" content={`${translate('seo.description')} ${name}`} />
          <meta property="og:title" content={name} />
          <meta property="og:description" content={`${translate('og.description')} ${name}`} />
        </Helmet>
      </>
    );
  };

  return (
    <div className={css.app}>
      {renderHelmet()}
      <Switch>
        <Route exact path={MAIN_PAGE_ROUTE}>
          <Main />
        </Route>
        <Redirect to={MAIN_PAGE_ROUTE} />
      </Switch>
    </div>
  );
};

export default App;
